import { IQuestion } from "./question.model";

const ACTION_SCOPE = '[Question]';

export class SetQuestionSearch {
    static readonly type = `${ACTION_SCOPE} Set Search Query`;
    constructor(public query: string) {}
}

// Get all Questions action
export class Questions {
    static readonly type = `${ACTION_SCOPE} Get Questions`
}

// Get single Question action
export class Question {
    static readonly type = `${ACTION_SCOPE} Get Question`
    constructor(public payload: string) { }
}

// Add Create Question action
export class CreateQuestion {
    static readonly type = `${ACTION_SCOPE} Create Question`;
    constructor(public payload: IQuestion) { }
}

// Add Update Question action
export class UpdateQuestion {
    static readonly type = `${ACTION_SCOPE} Update Question`;
    constructor(public payload: IQuestion, public id: string) { }
}

// Add Delete Question action
export class DeleteQuestion {
    static readonly type = `${ACTION_SCOPE} Delete Question`;
    constructor(public payload: string) { }  // payload is the Track ID
}

// Add Delete Question action
export class AssignRater {
    static readonly type = `${ACTION_SCOPE} Assign Rater`;
    constructor(public payload: string) { }  // payload is the Track ID
}